// Adult teeth data (32 permanent teeth) - Two-digit numbering system
export const adultTeeth = {
	upper: [
		{ number: 18, name: 'Third Molar', type: 'molar', position: 'upper-right' },
		{ number: 17, name: 'Second Molar', type: 'molar', position: 'upper-right' },
		{ number: 16, name: 'First Molar', type: 'molar', position: 'upper-right' },
		{ number: 15, name: 'Second Premolar', type: 'premolar', position: 'upper-right' },
		{ number: 14, name: 'First Premolar', type: 'premolar', position: 'upper-right' },
		{ number: 13, name: 'Canine', type: 'canine', position: 'upper-right' },
		{ number: 12, name: 'Lateral Incisor', type: 'incisor', position: 'upper-right' },
		{ number: 11, name: 'Central Incisor', type: 'incisor', position: 'upper-right' },
		{ number: 21, name: 'Central Incisor', type: 'incisor', position: 'upper-left' },
		{ number: 22, name: 'Lateral Incisor', type: 'incisor', position: 'upper-left' },
		{ number: 23, name: 'Canine', type: 'canine', position: 'upper-left' },
		{ number: 24, name: 'First Premolar', type: 'premolar', position: 'upper-left' },
		{ number: 25, name: 'Second Premolar', type: 'premolar', position: 'upper-left' },
		{ number: 26, name: 'First Molar', type: 'molar', position: 'upper-left' },
		{ number: 27, name: 'Second Molar', type: 'molar', position: 'upper-left' },
		{ number: 28, name: 'Third Molar', type: 'molar', position: 'upper-left' }
	],
	lower: [
		{ number: 38, name: 'Third Molar', type: 'molar', position: 'lower-left' },
		{ number: 37, name: 'Second Molar', type: 'molar', position: 'lower-left' },
		{ number: 36, name: 'First Molar', type: 'molar', position: 'lower-left' },
		{ number: 35, name: 'Second Premolar', type: 'premolar', position: 'lower-left' },
		{ number: 34, name: 'First Premolar', type: 'premolar', position: 'lower-left' },
		{ number: 33, name: 'Canine', type: 'canine', position: 'lower-left' },
		{ number: 32, name: 'Lateral Incisor', type: 'incisor', position: 'lower-left' },
		{ number: 31, name: 'Central Incisor', type: 'incisor', position: 'lower-left' },
		{ number: 41, name: 'Central Incisor', type: 'incisor', position: 'lower-right' },
		{ number: 42, name: 'Lateral Incisor', type: 'incisor', position: 'lower-right' },
		{ number: 43, name: 'Canine', type: 'canine', position: 'lower-right' },
		{ number: 44, name: 'First Premolar', type: 'premolar', position: 'lower-right' },
		{ number: 45, name: 'Second Premolar', type: 'premolar', position: 'lower-right' },
		{ number: 46, name: 'First Molar', type: 'molar', position: 'lower-right' },
		{ number: 47, name: 'Second Molar', type: 'molar', position: 'lower-right' },
		{ number: 48, name: 'Third Molar', type: 'molar', position: 'lower-right' }
	]
};

// Child teeth data (20 primary teeth) - Two-digit numbering system
export const childTeeth = {
	upper: [
		{ number: 55, name: 'Second Molar', type: 'molar', position: 'upper-right' },
		{ number: 54, name: 'First Molar', type: 'molar', position: 'upper-right' },
		{ number: 53, name: 'Canine', type: 'canine', position: 'upper-right' },
		{ number: 52, name: 'Lateral Incisor', type: 'incisor', position: 'upper-right' },
		{ number: 51, name: 'Central Incisor', type: 'incisor', position: 'upper-right' },
		{ number: 61, name: 'Central Incisor', type: 'incisor', position: 'upper-left' },
		{ number: 62, name: 'Lateral Incisor', type: 'incisor', position: 'upper-left' },
		{ number: 63, name: 'Canine', type: 'canine', position: 'upper-left' },
		{ number: 64, name: 'First Molar', type: 'molar', position: 'upper-left' },
		{ number: 65, name: 'Second Molar', type: 'molar', position: 'upper-left' }
	],
	lower: [
		{ number: 75, name: 'Second Molar', type: 'molar', position: 'lower-left' },
		{ number: 74, name: 'First Molar', type: 'molar', position: 'lower-left' },
		{ number: 73, name: 'Canine', type: 'canine', position: 'lower-left' },
		{ number: 72, name: 'Lateral Incisor', type: 'incisor', position: 'lower-left' },
		{ number: 71, name: 'Central Incisor', type: 'incisor', position: 'lower-left' },
		{ number: 81, name: 'Central Incisor', type: 'incisor', position: 'lower-right' },
		{ number: 82, name: 'Lateral Incisor', type: 'incisor', position: 'lower-right' },
		{ number: 83, name: 'Canine', type: 'canine', position: 'lower-right' },
		{ number: 84, name: 'First Molar', type: 'molar', position: 'lower-right' },
		{ number: 85, name: 'Second Molar', type: 'molar', position: 'lower-right' }
	]
};

// Teenage teeth data (24 mixed dentition teeth) - Two-digit numbering system
export const teenageTeeth = {
	upper: [
		{ number: 17, name: 'Second Molar', type: 'molar', position: 'upper-right' },
		{ number: 16, name: 'First Molar', type: 'molar', position: 'upper-right' },
		{ number: 15, name: 'Second Premolar', type: 'premolar', position: 'upper-right' },
		{ number: 14, name: 'First Premolar', type: 'premolar', position: 'upper-right' },
		{ number: 13, name: 'Canine', type: 'canine', position: 'upper-right' },
		{ number: 12, name: 'Lateral Incisor', type: 'incisor', position: 'upper-right' },
		{ number: 11, name: 'Central Incisor', type: 'incisor', position: 'upper-right' },
		{ number: 21, name: 'Central Incisor', type: 'incisor', position: 'upper-left' },
		{ number: 22, name: 'Lateral Incisor', type: 'incisor', position: 'upper-left' },
		{ number: 23, name: 'Canine', type: 'canine', position: 'upper-left' },
		{ number: 24, name: 'First Premolar', type: 'premolar', position: 'upper-left' },
		{ number: 25, name: 'Second Premolar', type: 'premolar', position: 'upper-left' },
		{ number: 26, name: 'First Molar', type: 'molar', position: 'upper-left' },
		{ number: 27, name: 'Second Molar', type: 'molar', position: 'upper-left' }
	],
	lower: [
		{ number: 37, name: 'Second Molar', type: 'molar', position: 'lower-left' },
		{ number: 36, name: 'First Molar', type: 'molar', position: 'lower-left' },
		{ number: 35, name: 'Second Premolar', type: 'premolar', position: 'lower-left' },
		{ number: 34, name: 'First Premolar', type: 'premolar', position: 'lower-left' },
		{ number: 33, name: 'Canine', type: 'canine', position: 'lower-left' },
		{ number: 32, name: 'Lateral Incisor', type: 'incisor', position: 'lower-left' },
		{ number: 31, name: 'Central Incisor', type: 'incisor', position: 'lower-left' },
		{ number: 41, name: 'Central Incisor', type: 'incisor', position: 'lower-right' },
		{ number: 42, name: 'Lateral Incisor', type: 'incisor', position: 'lower-right' },
		{ number: 43, name: 'Canine', type: 'canine', position: 'lower-right' },
		{ number: 44, name: 'First Premolar', type: 'premolar', position: 'lower-right' },
		{ number: 45, name: 'Second Premolar', type: 'premolar', position: 'lower-right' },
		{ number: 46, name: 'First Molar', type: 'molar', position: 'lower-right' },
		{ number: 47, name: 'Second Molar', type: 'molar', position: 'lower-right' }
	]
};

export const toothConditions = [
	{ value: 'abrasion', label: 'Abrasion', color: '#0dcaf0' },
	{ value: 'bridge', label: 'Bridge (Multiple Caps)', color: '#212529' },
	{ value: 'cavity', label: 'Cavity', color: '#dc3545' },
	{ value: 'cervical-abrasion', label: 'Cervical Abrasion', color: '#20c997' },
	{ value: 'crown', label: 'Crown', color: '#ffc107' },
	{ value: 'dental-implant', label: 'Dental Implant', color: '#0d6efd' },
	{ value: 'filling', label: 'Filling', color: '#6c757d' },
	{ value: 'fracture', label: 'Fracture', color: '#6f42c1' },
	{ value: 'healthy', label: 'Healthy', color: '#ffffff' },
	{ value: 'hypoplasia', label: 'Hypoplasia', color: '#6610f2' },
	{ value: 'missing', label: 'Missing', color: '#e9ecef' },
	{ value: 'pain', label: 'Pain', color: '#d63384' },
	{ value: 'root-canal', label: 'Root Canal', color: '#fd7e14' },
	{ value: 'tenderness', label: 'Tenderness', color: '#198754' },
];


export const treatmentTypes = [
	"Bridge",
	"Cleaning",
	"Crown",
	"Extraction",
	"Filling",
	"Implant",
	"Root Canal",
	"Scaling",
	"Whitening",
	"Other",
];

export const treatmentStatuses = [
	{ value: 'planned', label: 'Planned' },
	{ value: 'in-progress', label: 'In Progress' },
	{ value: 'completed', label: 'Completed' },
];